module.exports = __webpack_public_path__ + "static/media/HarborWordmarkBlack.e1d350b5.png";